import "rxjs/add/operator/map";

import { Types, Creators } from "../reducer";

import * as firebase from 'firebase';

const cancelRegistration = action =>
  firebase.database().ref(`registrations/${action.id}`).remove().then(() => {
    localStorage.removeItem("currentRegistrationId");
    return Creators.registrationCanceled();
  });

export default (action$, store) =>
  action$.ofType(Types.CANCEL_REGISTRATION).mergeMap(cancelRegistration);



// WEBPACK FOOTER //
// ./src/registration/epics/cancelRegistration.js